import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  TranslateModule,
  TranslateService,
  TranslateLoader,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
})
export class I18nModule {
  constructor(translate: TranslateService) {
    translate.addLangs(['de', 'en']);
    let browserLang =
      typeof localStorage !== 'undefined'
        ? localStorage.getItem('selectedLang')
        : null;
    if (browserLang === null) {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('selectedLang', 'en');
      }
      browserLang = 'en';
    }
    translate.use(browserLang);
  }
}
